import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureTrialAttribution } from "@/lib/trialAttribution";

/** 公開ページの初回流入をセッション内で保持する、表示を持たないコンポーネント。 */
export function TrialAttributionCapture() {
  const location = useLocation();

  useEffect(() => {
    // ログイン・招待・アンケート等の別目的の公開画面を流入元として混ぜない。
    if (
      location.pathname === "/trial" ||
      location.pathname.startsWith("/trial/") ||
      location.pathname === "/embed/calendar" ||
      location.pathname.startsWith("/embed/calendar/")
    ) {
      captureTrialAttribution();
    }
  }, [location.pathname, location.search]);

  return null;
}
